import React, { useState, useEffect } from 'react'

export default function YouTubeEmbed ({youtubeLink, height = "315", width = "560"}) {
    const [videoId, setVideoId] = useState('');

    // Function to extract the video ID from the share link
    const extractVideoIdFromLink = (link) => {
        const parts = link.split('/');
        const videoId = parts[parts.length - 1].split('?')[0];
        return videoId;
    };

    // When the component mounts or when youtubeLink prop changes
    React.useEffect(() => {
        const id = extractVideoIdFromLink(youtubeLink);
        setVideoId(id);
    }, [youtubeLink])

    return (
        <div className="youtube-embed">
            {videoId && (
                <iframe
                width={width}
                height={height}
                src={`https://www.youtube.com/embed/${videoId}`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                ></iframe>
            )}
        </div>
    )
}
